// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getTravels as listTravelsAPI,
    getTravel as getTravelAPI,
    addTravel as addTravelAPI,
    updateTravel as updateTravelAPI,
    deleteTravel as deleteTravelAPI,
} from '../../helpers/';

import { travelsApiResponseError, travelsApiResponseSuccess } from './actions';
import { TravelsActionTypes } from './constants';

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getTravel({ payload: { id } }) {
    try {
        const response = yield call(getTravelAPI, id );
        const travelItem = response.data.data;
        yield put(travelsApiResponseSuccess(TravelsActionTypes.GET_TRAVEL, travelItem));
    } catch (error) {
        yield put(travelsApiResponseError(TravelsActionTypes.GET_TRAVEL, error));
    }
}

function* addTravel({payload:travel}){
    try{
        const response = yield call(addTravelAPI,{...travel})
        const travelItem = response.data
        yield put(travelsApiResponseSuccess(TravelsActionTypes.ADD_TRAVEL,travelItem))
    } catch(error){
        yield put(travelsApiResponseError(TravelsActionTypes.ADD_TRAVEL,error))
    }
}

function* updateTravel({payload:travel}){
    try{
        const response = yield call(updateTravelAPI,{...travel})
        const travelItem = response.data.data
        yield put(travelsApiResponseSuccess(TravelsActionTypes.UPDATE_TRAVEL,travelItem))
    }catch(error){
        yield put(travelsApiResponseError(TravelsActionTypes.UPDATE_TRAVEL,error))
    }
}
function* deleteTravel({payload:{id}}){
    try{
        const response = yield call(deleteTravelAPI,id)
        const travelItem = response.data.id
        yield put(travelsApiResponseSuccess(TravelsActionTypes.DELETE_TRAVEL,travelItem))
    }catch(error){
        yield put(travelsApiResponseError(TravelsActionTypes.DELETE_TRAVEL,error))
    }
}

/**
 * List contactos
 */
function* listTravels({payload:params}) {
    try {
        const response = yield call(listTravelsAPI, { ...params });
        const listaTravels = response.data.data;
        yield put(travelsApiResponseSuccess(TravelsActionTypes.LIST_TRAVELS, listaTravels));
    } catch (error) {
        yield put(travelsApiResponseError(TravelsActionTypes.LIST_TRAVELS, error));
    }
}


export function* watchGetTravel(): any {
    yield takeEvery(TravelsActionTypes.GET_TRAVEL, getTravel);
}

export function* watchListTravels(): any {
    yield takeEvery(TravelsActionTypes.LIST_TRAVELS, listTravels);
}

export function* watchAddTravel():any{
    yield takeEvery(TravelsActionTypes.ADD_TRAVEL,addTravel)
}
export function* watchUpdateTravel():any{
    yield takeEvery(TravelsActionTypes.UPDATE_TRAVEL,updateTravel)
}
export function* watchDeleteTravel():any{
    yield takeEvery(TravelsActionTypes.DELETE_TRAVEL,deleteTravel)
}


function* travelsSaga(): any {
    yield all([
        fork(watchGetTravel),
        fork(watchListTravels),
        fork(watchAddTravel),
        fork(watchUpdateTravel),
        fork(watchDeleteTravel),
    ]);
}

export default travelsSaga;
